"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    fill: "currentColor",
    width: "100%",
    height: "100%",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 210.41 401",
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M348.73,74.39a8.5,8.5,0,0,0-8.09-5.89H267.36a8.5,8.5,0,0,0-8.09,5.89l-31.09,96.55,16.18,5.21,29.2-90.65h60.88l29.2,90.65,16.18-5.21Z",
      transform: "translate(-198.79 -68.5)"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M399.64,168.63a8.5,8.5,0,0,0-7.41-4.34H215.77a8.51,8.51,0,0,0-7.26,12.93l35.6,58.36a8.5,8.5,0,0,0,7.26,4.08h10.31v42.19a8.5,8.5,0,0,0,8.5,8.5h67.64a8.5,8.5,0,0,0,8.5-8.5V239.66h10.31a8.5,8.5,0,0,0,7.26-4.08l35.6-58.36A8.49,8.49,0,0,0,399.64,168.63ZM329.32,273.35H278.68V239.66h50.64Zm22.54-50.69H256.14l-25.23-41.37H377.09Z",
      transform: "translate(-198.79 -68.5)"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M408,396.67a8.49,8.49,0,0,0-7.31-4.17h-86L304,404.71,293.26,392.5h-86a8.5,8.5,0,0,0-7.45,12.58l32.82,60a8.51,8.51,0,0,0,7.45,4.42H367.89a8.51,8.51,0,0,0,7.45-4.42l32.82-60A8.5,8.5,0,0,0,408,396.67ZM362.85,452.5H245.15l-23.52-43H386.37Z",
      transform: "translate(-198.79 -68.5)"
    }), (0, jsx_runtime_1.jsx)("polygon", {
      points: "101.89 328.27 102.48 328.27 107.93 328.27 108.52 328.27 115.06 213.35 95.35 213.35 101.89 328.27"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M317.18,384.65a3.5,3.5,0,0,1-2.8-5.6L342.2,341.9a3.5,3.5,0,1,1,5.6,4.2L320,383.24A3.49,3.49,0,0,1,317.18,384.65Z",
      transform: "translate(-198.79 -68.5)"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M325.94,389.51a3.5,3.5,0,0,1-2.09-6.31l18.85-14a3.5,3.5,0,0,1,4.17,5.61l-18.84,14A3.47,3.47,0,0,1,325.94,389.51Z",
      transform: "translate(-198.79 -68.5)"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M290.45,384.65a3.5,3.5,0,0,1-2.81-1.41L259.82,346.1a3.5,3.5,0,0,1,5.61-4.2l27.81,37.15a3.5,3.5,0,0,1-2.79,5.6Z",
      transform: "translate(-198.79 -68.5)"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M281.68,389.51a3.44,3.44,0,0,1-2.08-.69l-18.85-14a3.5,3.5,0,1,1,4.18-5.61l18.84,14a3.5,3.5,0,0,1-2.09,6.31Z",
      transform: "translate(-198.79 -68.5)"
    })]
  });
};

exports.default = Icon;